import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { utils } from '@atlaskit/util-service-support';
import { InMemCache } from './in-mem-cache';
var DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
export function fetchAggResponseWithCache(_x) {
  return _fetchAggResponseWithCache.apply(this, arguments);
}
function _fetchAggResponseWithCache() {
  _fetchAggResponseWithCache = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var graphQuery, variables, operationName, _ref$aggAbsoluteUrl, url, cache, options, cachedResponse, inflightRequest, request;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          graphQuery = _ref.graphQuery, variables = _ref.variables, operationName = _ref.operationName, _ref$aggAbsoluteUrl = _ref.aggAbsoluteUrl, url = _ref$aggAbsoluteUrl === void 0 ? DEFAULT_GRAPHQL_ENDPOINT : _ref$aggAbsoluteUrl, cache = _ref.cache;
          options = {
            requestInit: {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
              })
            },
            queryParams: _objectSpread({}, operationName && {
              q: operationName
            })
          };
          cachedResponse = InMemCache.getData(cache.key);
          if (!(cachedResponse && InMemCache.isValid(cache.key))) {
            _context2.next = 5;
            break;
          }
          return _context2.abrupt("return", Promise.resolve(cachedResponse));
        case 5:
          // return a pending promise that was cached earlier
          inflightRequest = InMemCache.getInflightRequest(cache.key);
          if (!inflightRequest) {
            _context2.next = 8;
            break;
          }
          return _context2.abrupt("return", inflightRequest);
        case 8:
          // cache miss, fetch data from agg and store ref to promise
          request = new Promise( /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
              var response;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return utils.requestService({
                      url: url
                    }, options);
                  case 3:
                    response = _context.sent;
                    InMemCache.setData({
                      key: cache.key,
                      response: response,
                      ttl: cache.ttl
                    });
                    resolve(response);
                    _context.next = 11;
                    break;
                  case 8:
                    _context.prev = 8;
                    _context.t0 = _context["catch"](0);
                    reject(_context.t0);
                  case 11:
                    _context.prev = 11;
                    InMemCache.removeInflightRequest(cache.key);
                    return _context.finish(11);
                  case 14:
                  case "end":
                    return _context.stop();
                }
              }, _callee, null, [[0, 8, 11, 14]]);
            }));
            return function (_x2, _x3) {
              return _ref2.apply(this, arguments);
            };
          }());
          InMemCache.setInflightRequest({
            key: cache.key,
            request: request
          });
          return _context2.abrupt("return", request);
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _fetchAggResponseWithCache.apply(this, arguments);
}